import { Transform } from 'class-transformer';
import { ArrayMinSize, IsArray, IsNotEmpty, IsString } from 'class-validator';

/**
 * Payload for adding item numbers to a cart.
 */
export class AddCartItemDto {
  /**
   * Item numbers to add to the cart. Min 1.
   * @example ['29.99866', '3MD10420553']
   */
  @Transform(({ value }) =>
    Array.isArray(value) ? value.map((item) => (typeof item === 'string' ? item.trim() : item)) : value,
  )
  @IsArray()
  @ArrayMinSize(1)
  @IsString({ each: true })
  @IsNotEmpty({ each: true })
  public itemNumbers: string[];
}
